import { isTxtMsg } from '@core/pages/components/im/utils';
import type { CodeVo } from '@core/types/auto/oj';
import type {
  BusiOnlineStatusRequestVO,
  BusiOnlineStatusResponseVO,
  IMTeacherResp,
  MsgHistoryRequestVO,
  MsgHistoryResponseVO,
  MsgReadStatusRequestVO,
  MsgReadStatusResponseVO,
  MsgSendResponseVO,
  MsgVO,
  UnreadMsgCountsResponseVO,
} from '@core/types/im';
import { IM_API_BASE } from '@core/utils/environment';
import { GATEWAY_PREFIX_COMMON } from '@core/utils/runtime-config'
import { httpService } from './http';

/**
 * IM发送消息接口
 */
export function postMsgSend(data: MsgVO) {
  const url = isTxtMsg(data)
    ? `${IM_API_BASE}/im-business/v1/sensitive/msgSend`
    : `${IM_API_BASE}/im-business/v1/msgSend`;
  return httpService.post<MsgSendResponseVO>(url, {
    body: data,
    headers: httpService.COMMON_HEADERS,
  });
}

/**
 * 标记消息为已读
 */
export function postMsgReadStatus(data: MsgReadStatusRequestVO) {
  return httpService.post<MsgReadStatusResponseVO>(
    `${IM_API_BASE}/im-business/v1/msgReadStatus`,
    {
      body: data,
    },
  );
}

/**
 * 查询老师在线状态
 */
export function getBusiOnlineStatus(data: BusiOnlineStatusRequestVO) {
  return httpService.post<BusiOnlineStatusResponseVO>(
    `${IM_API_BASE}/im-business/v1/getBusiOnlineStatus`,
    {
      body: data,
    },
  );
}

/**
 * 查询未读消息数量
 */
export function getUnreadMsgCounts(query: { user: string }) {
  return httpService.get<UnreadMsgCountsResponseVO>(
    `${IM_API_BASE}/im-business/v1/unreadMsgCounts`,
    {
      query,
    },
  );
}

/**
 * 获取历史消息
 */
export function getMsgHistory(data: MsgHistoryRequestVO) {
  return httpService.post<MsgHistoryResponseVO>(
    `${IM_API_BASE}/im-business/v1/msgHistory`,
    {
      body: data,
    },
  );
}

export function uploadImFile(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return httpService.post<{ url: string }>(
    `/api/code-community-forum/api/upload/upload-im-file`,
    {
      body: formData,
    },
  );
}

export function getCodeSummary(data: { code: string; pid: number }) {
  return httpService.post<CodeVo>(
    `/api/code-community/api/im-business/get-code-summary`,
    {
      body: data,
    },
  );
}

/**
 * 通过gid和tid获取课导老师
 */
export function getClassTutor(query: { gid: string; tid: string }) {
  const url = `${GATEWAY_PREFIX_COMMON}/api/im-business/getClassTutor`;
  return httpService.get<IMTeacherResp>(url, { query });
}
